import { render } from "./ImportDataModal.vue?vue&type=template&id=316243d6&scoped=true&ts=true"
import script from "./ImportDataModal.vue?vue&type=script&lang=ts"
export * from "./ImportDataModal.vue?vue&type=script&lang=ts"

import "./ImportDataModal.vue?vue&type=style&index=0&id=316243d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-316243d6"]])

export default __exports__